import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AppType, parseAppType } from "@azm/core/enums/app-types";
import { resolveInternalHomeUrl } from "@azm/core/guards/internal-home";
import { AuthService } from "@azm/core/services/auth";
import { SidebarService } from "@azm/core/services/sidebar";

import { environment } from "@azm/environments/environment";

export const authGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const authService = inject(AuthService);
	const sidebarService = inject(SidebarService);

	let appType: AppType | null;
	try {
		const raw = localStorage.getItem(environment.appTypePropertyName);
		appType = raw ? parseAppType(atob(raw)) : null;
	} catch {
		appType = null;
	}

	if (appType !== environment.defaultAppType && authService.isAuthenticated && !state.url.includes("error")) {
		router.navigate(["/error/403"]);
		return false;
	}

	const nav = router.currentNavigation();
	const isLanding = nav?.extras?.state?.["isLanding"] ?? route.data["isLanding"];

	if (authService.isAuthenticated) {
		if (isLanding) {
			return resolveInternalHomeUrl(authService, sidebarService, router);
		}

		if (route.data["role"] && route.data["role"] !== authService.userRole) {
			router.navigate(["error/403"]);
			return false;
		}
	} else {
		if (!isLanding && typeof isLanding === "boolean") {
			if (state.url.includes("admin")) router.navigate(["/auth/admin"]);
			else router.navigate(["/"]);
			return false;
		}
	}

	return true;
};
